import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Assicurati che GSAP e ScrollTrigger siano pronti
gsap.registerPlugin(ScrollTrigger);

if (document.querySelector('.frase-scorrevole')) {
  // Funzione per calcolare la larghezza totale del viewport
  const viewportWidth = () => window.innerWidth;

  // Animazione per .frase-1
  document.querySelectorAll(".frase-1").forEach((element) => {
    gsap.to(element, {
      xPercent: -10,
      x: () => -viewportWidth(),
      ease: "none",
      scrollTrigger: {
        pinnedContainer: "#main",
        trigger: element,
        start: "top bottom", // Inizio quando il top dell'elemento è alla parte inferiore della viewport
        end: () => `+=${viewportWidth()} +200px`, // Fine dopo che l'elemento si è spostato fuori dalla viewport
        scrub: true, // Sincronizza l'animazione con lo scroll
        invalidateOnRefresh: true
      }
    });
  });

  // Animazione per .frase-2
  document.querySelectorAll(".frase-2").forEach((element) => {
    gsap.to(element, {
      xPercent: 10,
      x: () => viewportWidth(),
      ease: "none",
      scrollTrigger: {
        pinnedContainer: "#main",
        trigger: element,
        start: "top bottom", // Inizio quando il top dell'elemento è alla parte inferiore della viewport
        end: () => `+=${viewportWidth()} +200px`, // Fine dopo che l'elemento si è spostato fuori dalla viewport
        scrub: true, // Sincronizza l'animazione con lo scroll
        invalidateOnRefresh: true
      }
    });
  });
}
